import { render, staticRenderFns } from "./NavItemDropdownHover.vue?vue&type=template&id=641fd992&scoped=true"
import script from "./NavItemDropdownHover.vue?vue&type=script&lang=js"
export * from "./NavItemDropdownHover.vue?vue&type=script&lang=js"
import style0 from "./NavItemDropdownHover.vue?vue&type=style&index=0&id=641fd992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641fd992",
  null
  
)

export default component.exports